// libraries
import { get } from "@cloudspire/legacy-shared/src/libraries";

/**
 * Retourne les paramètres à passer en query-params en fonction des paramètres du formulaire.
 */
const roomGetQueryParameterForDetail = ({ parameterList }) => {
  const query = {} as any;

  if (get(parameterList, "checkin")) {
    query.checkin = parameterList.checkin;
  }

  if (get(parameterList, "checkout")) {
    query.checkout = parameterList.checkout;
  }

  if (get(parameterList, "capacity")) {
    query.capacity = parameterList.capacity;
  }

  if (get(parameterList, "nature")) {
    query.nature = parameterList.nature;
  }

  return query;
};

export default roomGetQueryParameterForDetail;
